import { AlarmSchedule } from "@visioni/a3s-alarm-schedules";

const defaultScheduleData = {
  schema_version: "1",
  metadata: {
    updated_at_utc: "2025-09-17T16:09:00Z",
    suggested_input_time_precision_in_minutes: 10,
    expected_time_precision_in_minutes: 1,
    timezone: "Australia/Sydney",
  },
  features: {
    monitoring: {
      default_state: "disarmed",
      allowed_states: ["armed", "disarmed"],
    },
    recording: {
      default_state: "disarmed",
      allowed_states: ["armed", "disarmed"],
    },
    sirens: {
      default_state: "disarmed",
      allowed_states: ["armed", "disarmed"],
    },
    strobes: {
      default_state: "disarmed",
      allowed_states: ["armed", "disarmed"],
    },
  },
  rules: [
    {
      id: "rule-1",
      name: "Weeknight Arming",
      kind: "weekly_pattern",
      features: {
        monitoring: "armed",
        sirens: "armed",
        strobes: "armed",
      },
      weekly_pattern: {
        effective_period: {
          start: null,
          end: null,
        },
        days: ["MON", "TUE", "WED", "THU", "FRI"],
        time_ranges: [
          {
            kind: "time_range",
            start: { hour: 18, minute: 0 },
            end: { hour: 6, minute: 0 },
          },
        ],
      },
    },
    {
      id: "rule-2",
      name: "Weekend Full Arming",
      kind: "weekly_pattern",
      features: {
        monitoring: "armed",
      },
      weekly_pattern: {
        effective_period: {
          start: { year: 2025, month: 7, day: 8, hour: 0, minute: 0 },
          end: { year: 2026, month: 2, day: 2, hour: 0, minute: 0 },
        },
        days: ["SAT", "SUN"],
        time_ranges: [
          {
            kind: "all_day",
          },
        ],
      },
    },
    {
      id: "rule-3",
      name: "Rotating Night Shift",
      kind: "rotating_pattern",
      features: {
        monitoring: "armed",
      },
      rotating_pattern: {
        effective_period: {
          start: null,
          end: null,
        },
        start: { year: 2025, month: 11, day: 11 },
        pattern: [
          {
            days: 5,
            time_ranges: [
              {
                kind: "time_range",
                start: { hour: 18, minute: 0 },
                end: { hour: 6, minute: 0 },
              },
            ],
          },
          {
            days: 6,
            time_ranges: [
              {
                kind: "all_day",
              },
            ],
          },
          {
            days: 2,
            time_ranges: [
              {
                kind: "time_range",
                start: { hour: 18, minute: 0 },
                end: { hour: 6, minute: 0 },
              },
            ],
          },
          { days: 1, is_off_day: true },
          {
            days: 5,
            time_ranges: [
              {
                kind: "all_day",
              },
            ],
          },
        ],
      },
    },
    {
      id: "rule-4",
      name: "Christmas Day",
      kind: "absolute_range",
      features: {
        monitoring: "armed",
      },
      absolute_range: {
        effective_period: {
          start: { year: 2025, month: 12, day: 25, hour: 0, minute: 0 },
          end: { year: 2025, month: 12, day: 25, hour: 23, minute: 59 },
        },
      },
    },
  ],
};

export const defaultSchedule: AlarmSchedule = AlarmSchedule.parse(defaultScheduleData);

const holidayShutdownScheduleData = {
  ...defaultScheduleData,
  metadata: {
    ...defaultScheduleData.metadata,
    updated_at_utc: "2025-11-30T09:00:00Z",
  },
  rules: [
    {
      id: "shutdown-1",
      name: "Holiday Shutdown",
      kind: "absolute_range",
      features: {
        monitoring: "disarmed",
        sirens: "disarmed",
        strobes: "disarmed",
      },
      absolute_range: {
        effective_period: {
          start: { year: 2025, month: 12, day: 24, hour: 18, minute: 0 },
          end: { year: 2026, month: 1, day: 2, hour: 6, minute: 0 },
        },
      },
    },
    {
      id: "shutdown-2",
      name: "Minimal Overnight Patrol",
      kind: "weekly_pattern",
      features: {
        monitoring: "armed",
      },
      weekly_pattern: {
        effective_period: {
          start: { year: 2025, month: 12, day: 24, hour: 18, minute: 0 },
          end: { year: 2026, month: 1, day: 2, hour: 6, minute: 0 },
        },
        days: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
        time_ranges: [
          {
            kind: "time_range",
            start: { hour: 0, minute: 0 },
            end: { hour: 5, minute: 0 },
          },
        ],
      },
    },
  ],
};
export const holidayShutdownSchedule: AlarmSchedule = AlarmSchedule.parse(holidayShutdownScheduleData);

const weekendMaintenanceScheduleData = {
  ...defaultScheduleData,
  metadata: {
    ...defaultScheduleData.metadata,
    updated_at_utc: "2025-08-01T06:00:00Z",
  },
  rules: [
    {
      id: "maint-1",
      name: "Maintenance Window",
      kind: "weekly_pattern",
      features: {
        monitoring: "disarmed",
        sirens: "disarmed",
      },
      weekly_pattern: {
        effective_period: {
          start: null,
          end: null,
        },
        days: ["SAT"],
        time_ranges: [
          {
            kind: "time_range",
            start: { hour: 6, minute: 0 },
            end: { hour: 15, minute: 0 },
          },
        ],
      },
    },
    {
      id: "maint-2",
      name: "Saturday Evening Re-arm",
      kind: "weekly_pattern",
      features: {
        monitoring: "armed",
        sirens: "armed",
      },
      weekly_pattern: {
        effective_period: {
          start: null,
          end: null,
        },
        days: ["SAT"],
        time_ranges: [
          {
            kind: "time_range",
            start: { hour: 15, minute: 0 },
            end: { hour: 23, minute: 59 },
          },
        ],
      },
    },
    {
      id: "maint-3",
      name: "Sunday Full Coverage",
      kind: "weekly_pattern",
      features: {
        monitoring: "armed",
        strobes: "armed",
      },
      weekly_pattern: {
        effective_period: {
          start: null,
          end: null,
        },
        days: ["SUN"],
        time_ranges: [
          {
            kind: "all_day",
          },
        ],
      },
    },
  ],
};
export const weekendMaintenanceSchedule: AlarmSchedule = AlarmSchedule.parse(weekendMaintenanceScheduleData);

export const mockSchedules = {
  defaultSchedule,
  holidayShutdownSchedule,
  weekendMaintenanceSchedule,
};
